import script from "./inputImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputImage.vue?vue&type=script&setup=true&lang=ts"

import "./inputImage.vue?vue&type=style&index=0&id=c891b0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c891b0b8"]])

export default __exports__